class ProductImageSlider extends HTMLElement {
    constructor() {
        super();
        this.lightroom;

        this.currentIndex = 0;
        this.lightroomInit = false;


        this.sliderOptions = { 
            slides: {
                perView: "auto",
                spacing: 0,
            }
        }

        this.thumbOptions = {
            slides: {
                perView: 8,
                spacing: 0,
            },
            breakpoints: {
                "(max-width: 767px)": {
                    slides: {
                        perView: 6,
                        spacing: 0,
                    }
                } 
            }
        }

        this.onInit();

    }

    onInit() {
        this.slider = new KeenSlider(".product-image-slider", this.sliderOptions, [this.onNavigation]);

        this.thumbnails = new KeenSlider(
            ".product-image-thumbs", 
            this.thumbOptions,
            [this.onThumbnailPlugin(this.slider)]
        );

        Array.from(document.querySelectorAll('.lightroom-button')).forEach(el => el.addEventListener("click", this.onLightRoomInit));

    }

    onNavigation(slider) {
        var arrowLeft = document.querySelector('.arrow--left_slider');
        var arrowRight = document.querySelector('.arrow--right_slider');

        arrowLeft.addEventListener("click", () => slider.prev());
        arrowRight.addEventListener("click", () => slider.next());
      
        function updateClasses() {
          var slide = slider.track.details.rel
          slide === 0
            ? arrowLeft.classList.add("arrow--disabled")
            : arrowLeft.classList.remove("arrow--disabled")
          slide === slider.track.details.slides.length - 1
            ? arrowRight.classList.add("arrow--disabled")
            : arrowRight.classList.remove("arrow--disabled")
        }
      
        slider.on("optionsChanged", () => {
          updateClasses()
        })
        slider.on("slideChanged", () => {
          updateClasses()
        })
    }


    onLightRoomInit(event) {
        if(this.lightroomInit) return;
        this.lightroom = lightGallery( event.currentTarget.parentNode, {
            plugins: [lgZoom, lgThumbnail],
            thumbnail: true,
            preload: 1,
            getCaptionFromTitleOrAlt: false,
            download: false,
            licenseKey: 'C096F77D-92294C64-9C2C7CFD-FF6E4A4F',
            mobileSettings: {
                controls: true,
            },
        });

        this.lightroom.openGallery();
        this.lightroomInit = true;
    }

    onDestroy() {
        this.currentIndex = 0;
        this.slider.destroy();
        this.thumbnails.destroy();
    }

    onUpdate() {
        var arrowLeft = document.querySelector('.arrow--left_slider');
        var arrowRight = document.querySelector('.arrow--right_slider');

        Array.from(document.querySelectorAll('.lightroom-button')).forEach(el => el.removeEventListener("click", this.onLightRoomInit));

        this.onDestroy();
        this.onInit();
        this.slider.moveToIdx(0, false, { duration: 0 });
        this.thumbnails.moveToIdx(0, false, { duration: 0 });

       arrowLeft.classList.add("arrow--disabled");
       arrowRight.classList.remove("arrow--disabled");
    }

    onThumbnailPlugin(main) {
        return (slider) => {
            function removeActive() {
                slider.slides.forEach((slide) => {
                    slide.classList.remove("active")
                })
            }
            function addActive(idx) {
                slider.slides[idx].classList.add("active")
            }

            function addClickEvents() {
                slider.slides.forEach((slide, idx) => {
                    slide.addEventListener("click", () => {
                        main.moveToIdx(idx)
                    })
                })
            }

            slider.on("created", () => {
                addActive(slider.track.details.rel)
                addClickEvents()
                main.on("animationStarted", (main) => {
                    removeActive()
                    const next = main.animator.targetIdx || 0
                    addActive(main.track.absToRel(next))
                    slider.moveToIdx(next)
                })
            })
        }
    }

}

customElements.define('product-image-slider', ProductImageSlider);